// extracted by mini-css-extract-plugin
export default {"container":"NoCurrentFloorFacilityPopup_container__qW2Nx","text":"NoCurrentFloorFacilityPopup_text__vduLn"};